exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (max-width:840px){.mdl-tabs__panel>.scrollbar[_v-29212bf6]{max-height:400px}}@media only screen and (min-width:840px){.mdl-tabs__panel>.scrollbar[_v-29212bf6]{max-height:750px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-29212bf6&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/segments/FAQ.vue
// module id = 298
// module chunks = 0